import { useContext } from "react";
import { useLocation, Outlet, Navigate } from "react-router-dom";

import React from "react";

import AuthContext from "../contexts/AuthContext";

function PrivateRoute() {
  const auth = useContext(AuthContext);
  const location = useLocation();

  return auth.token ? (
    <Outlet />
  ) : (
    <Navigate to={"/login"} replace state={{ from: location }} />
  );
}

export default PrivateRoute;
